import React from 'react';
import { Row, Col } from 'react-bootstrap';
import RichText from './content-types/RichText';
import '../styles/content.scss';

// For double-layout sections we render two side-by-side rich-text blocks.
// `content` here is the full section item from the API.
const ContentRenderer = ({ content }) => {
  if (content?.layout === 'double') {
    return (
      <div className="content-section">
        {content.title ? <h3>{content.title}</h3> : null}
        <Row>
          <Col md={6}>
            <RichText content={{ content: content.content || '' }} />
          </Col>
          <Col md={6}>
            <RichText content={{ content: content.secondaryContent || '' }} />
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div className="content-section">
      {content?.title ? <h3>{content.title}</h3> : null}
      <RichText content={content} />
    </div>
  );
};

export default ContentRenderer;
